import React from 'react';

import { Icon } from '../../../../components/Icon';
import { FormattedMessage } from '../../../../i18n';
import { Language } from '../../consts';

interface LanguageLabelProps {
    lang: string;
}
const LanguageLabel = ({ lang }: LanguageLabelProps) => (
    <FormattedMessage message={__('{lang}')} values={{ lang }} />
);

interface LocaleSwitcherLanguageProps {
    language: Language;
}

function LocaleSwitcherLanguage({ language }: LocaleSwitcherLanguageProps) {
    const lang = language.getLanguage();

    if (language.isCurrent()) return <LanguageLabel lang={lang} />;

    return (
        <a
            className="footer-level-nav__item__link"
            href={`/user/switch-language/${language.getRfcLocale()}`}
        >
            <LanguageLabel lang={lang} />
        </a>
    );
}

interface Props {
    languages: Language[];
}

export default function LocaleSwitcher({ languages }: Props) {
    return (
        <div className="locale-switcher">
            <span className="locale-switcher__icon">
                <Icon type={'globe-1'} />
            </span>
            <div className="locale-switcher__nav">
                <ul className="footer-level-nav">
                    {languages.map(language => (
                        <li
                            className="footer-level-nav__item"
                            key={language.toString()}
                            data-state={language.isCurrent() ? 'selected' : null}
                        >
                            <LocaleSwitcherLanguage language={language} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
